import { render, staticRenderFns } from "./ViewportMotion.vue?vue&type=template&id=1c33c4e1&scoped=true"
import script from "./ViewportMotion.vue?vue&type=script&lang=js"
export * from "./ViewportMotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c33c4e1",
  null
  
)

export default component.exports